<template>
  <div class="cvs-job-main" @click="toDetails">
    <div class="item-pic">
      <img :src="data.company_logo || 'https://files.wondercv.com/cvsvue/Artboard.png'" alt="">
    </div>
    <div class="item-info">
      <div class="item-company-name text-overflow">{{data.company_nick_name || data.company_name}}</div>
      <div class="item-recruit text-overflow">{{data.job_post}}</div>
      <div class="item-msg">
        <div class="item-msg-content">
          <i class="iconfont iconmap-pin"></i>
          <div class="item-msg-city text-overflow" v-if="!data.city_names || !data.city_names.length">
            <span>全国</span>
          </div>
          <div class="item-msg-city text-overflow">
            <span v-for="(city, num) in data.city_names" :key="num">{{city}}</span>
          </div>
          <i class="iconfont iconclock"></i>
          <span style="margin-left: 4px;">{{data.updated_at}}</span>
        </div>
        <div class="item-money">{{data.display_salary}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { routerTo } from '@/assets/js/util';
import moment from 'moment';
export default {
  name: 'Job',
  props: ['data'],
  data() {
    return {
      moment
    }
  },
  methods: {
    toDetails() {
      routerTo(`/jobs/${this.data.token}.html`);
    }
  },
}
</script>
<style lang="scss" scoped>
.cvs-job-main {
  width: 406px;
  height: 110px;
  border: 1px solid #ECECEC;
  margin-bottom: 16px;
  display: flex;
  cursor: pointer;
  .item-pic {
    width: 64px;
    height: 64px;
    // border: 1px solid #E3E3E3;
    margin: 23px;
    margin-right: 18px;
    position: relative;
    img {
      max-width: 100%;
      max-height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      // margin: 15px;
    }
  }
  .item-info {
    width: calc(100% - 64px - 40px);
    flex: none;
    margin-top: 23px;
    .item-company-name {
      width: calc(100% - 34px);
      font-size: 16px;
      color: #404040;
      font-weight: 600;
    }
    .item-recruit {
      width: calc(100% - 34px);
      height: 18px;
      line-height: 18px;
      font-size: 13px;
      color: #404040;
      margin-top: 4px;
      margin-bottom: 11px;
    }
    .item-msg {
      width: 100%;
      font-size: 12px;
      color: #909090;
      display: flex;
      justify-content: space-between;
      .item-msg-content {
        display: flex;
        align-items: center;
        .item-msg-city {
          max-width: 110px;
          margin-left: 4px;
        }
      }
      .iconfont {
        font-size: 12px;
      }
      span {
        margin-right: 8px;
      }
      .item-money {
        margin-right: 18px;
        font-size: 13px;
        color: #ff4f4c;
      }
    }
  }
}
</style>